
import chart from './template/echarts/echarts.vue';
import Base from './base.js';
import Vue from 'vue';
import Gikam from '../core/gikam-core';

export default class Echarts extends Base {

    constructor(options) {
        super(options);
        this.listeners = {
            //echarts初始化完成之后,参数为echarts对象
            ready: Gikam.emptyFunction
        };
        this.initialize(options).init();
    }

    createViewModel() {
        const _this = this;
        this.model = new Vue({
            el: Gikam.createDom('div', this.options.renderTo),
            render() {
                return <chart ref='vm'
                    options={this.options.option}
                    id={this.options.id}
                    onReady={(echarts) => {
                        _this.trigger('ready', echarts);
                    }}></chart>;
            },
            components: { chart },
            data() {
                return {
                    options: _this.options
                };
            }
        });

        this.model.$nextTick(() => {
            this.bindInstance(this.model.$refs.vm.$el);
        });
    }

    /* 调用echarts的setOptions方法更新图标参数 */
    setOption(options, refreshFlag) {
        this.model.$refs.vm.echarts.setOption(options, refreshFlag);
    }

    init() {
        this.createViewModel();
    }

}